import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Label from './label';
import styles from './text.css';

const InputText = ({
  name,
  placeholder,
  label,
  value,
  onChange,
  required,
  inputRef,
  className,
  error,
  type,
  maxLength,
  shouldHideLabel,
  onKeyDown,
}) => {
  const inputComponent = (<input
    className={styles.input}
    type={type}
    placeholder={placeholder}
    name={name}
    ref={inputRef}
    value={value}
    onChange={onChange}
    required={required}
    maxLength={maxLength}
    onKeyDown={onKeyDown}
    {...shouldHideLabel ? { 'aria-label': label } : {}}
  />);

  return (
    <div className={classNames(
      styles.inputWrapper,
      className,
      { [styles.error]: !!error },
    )}
    >
      {shouldHideLabel ?
        inputComponent :
        <Label
          htmlFor={name}
          text={label}
          required={required}
          className={styles.label}
        >
          {inputComponent}
        </Label>
      }
      {!!error &&
        <span className={styles.errorText}>{error}</span>
      }
    </div>
  );
};

InputText.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(HTMLInputElement) }),
  ]),
  required: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.string,
  shouldHideLabel: PropTypes.bool,
  onKeyDown: PropTypes.func,
};

InputText.defaultProps = {
  placeholder: '',
  value: '',
  inputRef: () => {},
  required: false,
  className: '',
  error: '',
  type: 'text',
  maxLength: '50',
  shouldHideLabel: false,
  onKeyDown: () => {},
};

export default withStyles(styles)(InputText);
